import { HubertButton } from 'components/HubertUI/HubertButton';
import { CircleOff, Ruler, TriangleAlert, Weight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EMatrixEvaluationType } from 'types/evaluation.types';

interface Props {
  evaluationType: EMatrixEvaluationType | '';
}

const MatrixEvaluationTriggerButton = ({ evaluationType }: Props) => {
  const { t } = useTranslation('Templates');

  if (evaluationType === '') {
    return (
      <HubertButton size="sm" variant={'outline'} icon={<CircleOff />}>
        <div>{t('evaluationPopover.triggerButton.notSet')}</div>
      </HubertButton>
    );
  } else if (evaluationType === EMatrixEvaluationType.Weighted) {
    return (
      <HubertButton size="sm" variant={'outline'} icon={<Weight />}>
        <div>{t('evaluationPopover.triggerButton.weighted')}</div>
      </HubertButton>
    );
  } else if (evaluationType === EMatrixEvaluationType.Conditional) {
    return (
      <HubertButton size="sm" variant={'outline'} icon={<Ruler />}>
        <div>{t('evaluationPopover.triggerButton.conditionalRules')}</div>
      </HubertButton>
    );
  } else {
    return (
      <HubertButton size="sm" variant={'destructive'} icon={<TriangleAlert />}>
        <div>{t('evaluationPopover.triggerButton.error')}</div>
      </HubertButton>
    );
  }
};

export default MatrixEvaluationTriggerButton;
